export default __webpack_public_path__ + "static/media/LOADING-GIF.53cf423b.gif";